import { useState, MouseEvent } from "react";
import { Button } from "@mui/material";
import ApplyNowForm from "./ApplyNowForm";

interface ApplyNowButtonProps {
  label?: string;
}

const ApplyNowButton: React.FC<ApplyNowButtonProps> = ({
  label = "Apply Now",
}) => {
  const [open, setOpen] = useState(false);

  //const handleOpenForm = () => setOpen(true);
  const handleCloseForm = () => setOpen(false);
  const handleOpenEmail = (e: MouseEvent) => {
    window.location.href = "mailto:daniel@hungerfordconsulting.com";
    e.preventDefault();
  };
  //daniel@hungerfordconsulting.com
  return (
    <>
      <Button
        variant="contained"
        color="primary"
        size="large"
        onClick={handleOpenEmail}
        //onClick={handleOpenForm}
        sx={{
          px: 6,
          py: 1.5,
          borderRadius: 1,
          textTransform: "none",
          fontWeight: 600,
          fontSize: "1rem",
          mt: 2,
        }}
      >
        {label}
      </Button>

      <ApplyNowForm open={open} handleClose={handleCloseForm} />
    </>
  );
};

export default ApplyNowButton;
